import { ComponentProps } from 'react'
import styled from 'styled-components'

import { Column, Media as MediaLMF, untilMd, zIndexForeground } from '@syconium/little-miss-figgy'
import { fromMd } from '@syconium/little-miss-figgy'

export const Section = styled.section`
  padding: 0px;
  margin-bottom: 40px;

  ${fromMd} {
    padding: 0px 40px;
  }
`
export const FilterColumn = styled(Column)`
  ${untilMd} {
    background: white;
    position: sticky;
    top: 0;
    z-index: ${zIndexForeground};
    padding: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;
  }
`

export const FilterBarWrap = styled.div`
  background: white;
  margin: 0 -40px;
  padding: 0 40px;
`

export const FilterBarMedia = styled((props: ComponentProps<typeof MediaLMF>) => {
  return <MediaLMF {...props} />
})`
  position: sticky;
  top: 60px;
  z-index: 199;
`
